import React, { useState, useEffect } from 'react';

export default function Navbar() {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const sections = ['about', 'how', 'leaderboard', 'reviews', 'callback'];
    const handler = () => {
      const scrollPos = window.scrollY + 100;
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollPos && el.offsetTop + el.offsetHeight > scrollPos) {
          setActiveSection(id);
          return;
        }
      }
      setActiveSection('');
    };
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <nav className="nav">
      <div className="nav-logo">
        <img src="/images/rushputt_logo.png" alt="RushPutt Logo" />
      </div>
      <ul className="nav-links">
        <li><a href="#about" className={activeSection === 'about' ? 'active' : ''}>About</a></li>
        <li><a href="#how" className={activeSection === 'how' ? 'active' : ''}>How It Works</a></li>
        <li><a href="#leaderboard" className={activeSection === 'leaderboard' ? 'active' : ''}>Leaderboards</a></li>
        <li><a href="#reviews" className={activeSection === 'reviews' ? 'active' : ''}>Reviews</a></li>
        <li><a href="#callback" className="nav-cta">Book Now</a></li>
      </ul>
    </nav>
  );
}
